import { ArticleType } from '../../../store/article/list';

export interface WithArticleTypeProps {
  articleType: ArticleType
}

export enum ArticleTypeEnum {
  BLOG = 'blog',
  HISTORY = 'history',
  PSYCHOLOGY = 'psychology',
}

export enum ArticleTypeDisplayName {
  blog = 'Blog',
  history = 'History',
  psychology = 'Psychology',
}

export enum ArticleTypeDisplayTable {
  blog = 'Blog Articles',
  history = 'History of tipping',
  psychology = 'Psychology of tipping',
}
